/**
 * ダミー画像
 */
const dummyImage = (ratio) => {
  const dummySquare = "/assets/images/admin/common/dummy04.png";
  const dummyRectangle = "/assets/images/admin/common/dummy05.png";

  return ratio === 1 || ratio === undefined ? dummySquare : dummyRectangle;
};

/**
 * 幅指定画像属性情報出力(src, width, height)
 *
 * @param {int} width 出力予定の幅
 * @param {string} imagePath 画像URLパス
 * @param {{ name: string, heightRatio: float }}
 * @returns {{src: string, width: int, height: int}}
 */
export const createAttributeWidthFix = (
  width,
  imagePath,
  { name, heightRatio },
) => {
  const height = parseInt(width * (heightRatio || 1), 10);
  const src = name
    ? `${imagePath}${name}?width=${width}`
    : dummyImage(heightRatio);

  const imgStyle = {
    width: parseInt(width / 2, 10),
    height: parseInt(height / 2, 10),
  };

  return { src, ...imgStyle };
};

/**
 * 高さ指定画像属性情報出力(src, width, height)
 *
 * @param {int} height 出力予定の高さ
 * @param {string} imagePath 画像URLパス
 * @param {{ name: string, heightRatio: float }}
 * @returns {{src: string, width: int, height: int}}
 */
export const createAttributeHeightFix = (
  height,
  imagePath,
  { name, heightRatio },
) => {
  const width = parseInt(height / (heightRatio || 1), 10);
  const src = name
    ? `${imagePath}${name}?height=${height}`
    : dummyImage(heightRatio);

  const imgStyle = {
    width: parseInt(width / 2, 10),
    height: parseInt(height / 2, 10),
  };

  return { src, ...imgStyle };
};
